'use strict';

module.exports = require('./dom-scroll-into-view');